// 产品应用
const productApplication = {
  title: 'KELK 产品应用',
  content: '可承揽各种品牌的控制阀检修维护服务。公司在全国各地设有维修服务基地，配有移动式车间及配套的维修设备，可以根据实际需求为广大用户提供在现场和返厂维修等多种形式的维修服务。凯尔克公司为石油、石化、冶金、电力等工业控制领域和仪器仪表行业供应设备和维护设备超过60年，特别是控制阀和具有高技术含量的控制设备以及客户支持服务扭矩偏小，有少量酸泥堆积时便难于动作。'
}

// 解决方案
const solution = {
  title: 'KELK 工程解决方案',
  content: '凯尔克公司为石油天然气、石化化工、精细化工、冶金有色、工业气体、能源环保、电力拖动等工业控制领域和仪器仪表行 业供应设备和维护设备超过60年，特别是控制阀和具有高技术含量的控制设备以及客户支持服务。',
}
// 产品应用
const application = {
  tagListAll: [{
    name: '全部',
    id: ''
  }]
}
// 产品案例
const productCase = {
  tagListAll: [{
    name: '全部',
    id: ''
  }]
}
// 解决方案
const solutionCase = {
  tagListAll: [{
    name: '全部',
    id: ''
  }]
}
// 服务案例
const maintenanceCase = {
  tagListAll: [{
    name: '全部',
    id: ''
  }]
}

const programDetail = {
  footArticleBtnTxt: '查看详情'
}


export default {
  title: '产品方案',
  tabs: [
    '产品应用',
    '解决方案',
    '产品案例',
    '服务案例',
  ],
  subTitle: 'KELK 产品方案',
  contentTitle1:'地区',
  contentTitle2:'客户',
  contentTitle3:'产品',
  contentTitle4:'行业/装置',
  contentTitle5:'工况/介质',
  productApplication,
  solution,
  productCase,
  maintenanceCase,
  programDetail,
  application,
  solutionCase,
  downloadName:'资料下载'
}


// WEBPACK FOOTER //
// ./src/config/lang/zh-CN/productProgramPage.js